module.exports = __webpack_public_path__ + "img/hand.dec5405a.png";